export default __webpack_public_path__ + "static/media/case3.4d896395.webp";